import { SearchOutlined } from '@ant-design/icons';
import { LegendTable } from '@/components/Legend/LegendTable';
import { useState } from 'react';
import { Button, DataGrid, Input } from '@hydrodigital/design-system';

export const ParameterTable = ({
	columnsExpanded,
	dataTable,
	expandedRowRender,
	expandedRowKeys,
	disableDownloadReport,
	onSearch,
	notesForParams,
	rowSelectionState,
	onRowSelectionChange,
	setIsReportModalOpen,
}: any) => {
	const legendInfo = [
		{ label: 'Less than 0%', color: '#22a2ca' },
		{ label: '0% - 33%', color: '#34c38f' },
		{ label: '33% - 66%', color: '#ffd992' },
		{ label: '66% - 100%', color: '#e3a63d' },
		{ label: 'Greater than 100%', color: '#f46a6a' },
	];
	return (
		<div className="flex column w-full">
			<div className="flex justify-between items-center" style={{ marginBottom: '1rem' }}>
				<div className="flex items-center">
					<span
						className="mr-2"
						style={{
							color: '#023E65',
							fontWeight: 'bold',
							textTransform: 'uppercase',
						}}
					>
						Parameter summary
					</span>
					<Input
						placeholder="Search Parameters"
						leftIcon={<SearchOutlined />}
						style={{ width: '205px' }}
						size='small'
						onChange={(e) => onSearch(e.target.value)}
					/>
				</div>
				<div className="flex items-center">
					{notesForParams}
					<Button
						className="ml-2"
						variant="primary"
						iconName='download'
						disabled={disableDownloadReport}
						onClick={() => {
							setIsReportModalOpen(true);
						}}
						label="Download report"
					/>
				</div>
			</div>
			<div className="flex w-full justify-start mt-2 mb-1">
				<LegendTable data={legendInfo} fontSize="small" />
			</div>
			<div>
				<DataGrid
					columns={columnsExpanded}
					data={dataTable}
					// expandable={{
					// 	expandedRowRender,
					// 	expandedRowKeys,
					// 	showExpandColumn: false,
					// }}
					style={{ overflowX: 'auto' }}
					pagination={{ enabled: false }}
					selection={{
						enabled: true,
						mode: 'multiple',
						showSelectAll: false,
					}}
					emptyMessage={
						<div className="flex column">
							<span>No data: select some data to turn on the light</span>
						</div>
					}
					rowSelection={rowSelectionState}
					onRowSelectionChange={onRowSelectionChange}
					striped={true}
					hoverable={true}
					bordered={true}
				/>
			</div>
		</div>
	);
};
